export const SENTRY_DSN =
  "https://176cf47116ca4798ae0de941b0da6f9f@o376633.ingest.sentry.io/5197633"
export const POSTHOG_API_KEY = process.env.REACT_APP_POSTHOG_API_KEY
export const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || "https://app.posthog.com"
export const CLOUD_URL = "https://us-central1-oriserve-bcd30.cloudfunctions.net"
export const NETWORK_CHECK_URL = "https://www.google.com/"
export const LAMBDA_URL= process.env.REACT_APP_LAMBDA_URL
export const BASE_URL_USERS = process.env.REACT_APP_BASE_URL_USERS
export const BASE_URL = process.env.REACT_APP_BASE_URL
export const BASE_SOCKET_URL = process.env.REACT_APP_BASE_SOCKET_URL
export const BASE_URL_CAMPAIGN = process.env.REACT_APP_BASE_URL_CAMPAIGN
export const SOCKET_URLS = {
  LIVE_CONVERSATIONS_SOCKET_URL: `${BASE_SOCKET_URL}/liveConversations`,
  LIVE_CHATS_STATS_SOCKET_URL: `${BASE_SOCKET_URL}/liveChatsStats`,
  LIVE_ADMINS_SOCKET_URL: `${BASE_SOCKET_URL}/liveAdmins`,
  LIVE_TICKETS_SOCKET_URL: `${BASE_SOCKET_URL}/liveTickets`,
  DIALOGUE_SOCKET_URL: `${BASE_SOCKET_URL}/liveDialogTraining`
}
